import { Component, ElementRef, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbCalendar, NgbDateParserFormatter, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { PublishersContentService } from './services/publishers.Content.Service';
import { AuthorsContentService } from './services/authors.Content.Service';
import { WritersContentService } from './services/writers.Content.Service';
import { lectureContentService } from './services/lecture.Content.Service';

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent implements OnChanges{
	
	@Input() showSearch: boolean = false;
	@Input() searchPlaceholder: string = 'Search anything...';
	@Input() yearsplaceholder: string = 'Search anything...';

	@Input() authorsPlaceholder?: any ;

	@Input() showDateFrom: boolean = false;
	@Input() showDateTo: boolean = false;
	@Input() showDepartment: boolean = false;
	@Input() showTrainer: boolean = false;
	@Input() showYears: boolean = false;
	@Input() showAuthors: boolean = false;
	@Input() showWriter: boolean = false;
	@Input() showAllyears: boolean = false;
	@Input() showDate: boolean = false;
	@Input() showPublisher: boolean = false;
	
	@Output() filterEvent = new EventEmitter<FormGroup>();
	@ViewChild('searchInput') searchInput:any ;
	
	
	 filterForm!:FormGroup

	
	bsValue?: any;
	bsRangeValue?: any;
	selectedValue: string = '';
	
	allYearsArray:any[] =  [];
	PublishersArray:any []= [];
	writersArray:any []= [];
	lecturesArray:any [] = [];

	maxDate = new Date();
	constructor(
		private _PublishersContentService:PublishersContentService,
		// private _AuthorsContentService:AuthorsContentService,
		private _WritersContentService:WritersContentService,
		private _lectureContentService:lectureContentService
	) {

		this.filterForm = new FormGroup ({
			search: new FormControl(null),
			authors:new FormControl(null),
			allyears: new FormControl(null),
			publisher: new FormControl(null),
			fromtodate: new FormControl(null),
			witerid: new FormControl(null),
			lectureid:new FormControl(null)
		});


		this.filterForm.valueChanges.subscribe((res:any)=>{
		console.log("ksnfknskdjuriwuik",this.filterForm)
			this.filterEvent.emit(this.filterForm);
		});



	
	



		// generateYearsArray
		const currentYear = new Date().getFullYear();
		this.allYearsArray = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => currentYear - i);
		// console.log("sfdksdf",this.allYearsArray);
	}
	ngOnChanges(changes: SimpleChanges): void {
		
		if(this.showPublisher){
			this._PublishersContentService.watch().valueChanges.subscribe((res:any)=>{
				if((res !=undefined) && (res['data']['queryPublishersContents'])){
					this.PublishersArray = res['data']['queryPublishersContents'];
					console.log("dklsnsf",res)
				}
			})
		}

		if(this.showWriter){
			this._WritersContentService.watch().valueChanges.subscribe((res:any)=>{
				if((res !=undefined) && (res['data']['queryWritersContents'])){
					this.writersArray = res['data']['queryWritersContents'];
					
				}
				console.log("sassssssssffdf",res)
			})
		}

		if(this.showTrainer){
			this._lectureContentService.watch().valueChanges.subscribe((res:any)=>{
				if((res !=undefined) && (res['data']['queryLecturersContents'])){
					this.lecturesArray = res['data']['queryLecturersContents'];
					
				}
				console.log("sassssssssffdf",res)
			})
		}

		
	}
	options = [
	  { value: 'option1', label: 'Option 1' },
	  { value: 'option2', label: 'Option 2' },
	  { value: 'option3', label: 'Option 3' }
	];
  department?:any=null
  trainer?:any;
    year?:any;
	author?:any;
	writer?:any;
	report?:any;


	
  searchText: string = '';
  dateFrom?: Date;
  dateTo?: Date;

  bsConfig?: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MM-YYYY',
	// dateInputFormat: 'YYYY-MM-DD',
    containerClass: 'theme-blue',
	showWeekNumbers: false,
  };
  mydate:any
	calendar = inject(NgbCalendar);
	formatter = inject(NgbDateParserFormatter);

	hoveredDate: NgbDate | null = null;
	fromDate: NgbDate | null = this.calendar.getToday();
	toDate: NgbDate | null = this.calendar.getNext(this.calendar.getToday(), 'd', 10);


	search(event: Event): void {
		const keyboardEvent = event as KeyboardEvent; // Cast to KeyboardEvent
		const inputValue = (keyboardEvent.target as HTMLInputElement).value;
		this.filterForm.get('search')?.setValue(inputValue);
	}


  onDateSelection(date: NgbDate) {
		if (!this.fromDate && !this.toDate) {
			this.fromDate = date;
		} else if (this.fromDate && !this.toDate && date && date.after(this.fromDate)) {
			this.toDate = date;
		} else {
			this.toDate = null;
			this.fromDate = date;
		}
	}

	isHovered(date: NgbDate) {
		return (
			this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate)
		);
	}

	isInside(date: NgbDate) {
		return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
	}

	isRange(date: NgbDate) {
		return (
			date.equals(this.fromDate) ||
			(this.toDate && date.equals(this.toDate)) ||
			this.isInside(date) ||
			this.isHovered(date)
		);
	}

	validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
		const parsed = this.formatter.parse(input);
		return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
	}
 
}
